<template>
  <div>
    <div
      v-for="ques in pollQuestionList"
      v-bind:key="ques.QuesID"
      class="voting-area attendee-poll-wrapper"
      :id="ques.QuesID + '_VotingArea'"
    >
      <div v-if="questionId == ques.QuesID">
        <div
          v-if="questionId == ques.QuesID"
          :id="'divblock' + ques.QuesID"
          style="position: relative"
        >
          <div
            v-if="ques.fieldtype === 'checkboxes'"
            class="Quesboxoption multiple-ans"
          >
            <div class="vote-result-area">
              <div class="submit-vote-wrapper" id="dvPollResult">
                <div class="multiple-ans">
                  <ul v-if="ques.vote">
                    <li
                      v-for="(optvote, index) in ques.vote"
                      v-bind:key="index"
                      :class="
                        index == 0 ? 'vote-ans currect-ans-box' : 'vote-ans'
                      "
                    >
                      <div
                        :style="
                          'width:' +
                          ((optvote.count / ques.totVote) * 100).toFixed() +
                          '%;'
                        "
                        class="inner-progress-bar"
                      ></div>
                      <label class="container-vote-ans"
                        >{{ optvote.optionId }}
                        <input
                          type="checkbox"
                          name="radio1"
                          checked
                          disabled
                          class="isvotechecked"
                        />
                        <span class="checkmark-vote-ans"
                          ><div class="counter-text">
                            {{ optionChar[index] }}
                          </div></span
                        >
                      </label>
                      <span class="skill"
                        ><i class="val">
                          {{
                            ((optvote.count / ques.totVote) * 100).toFixed() +
                            "%"
                          }}</i
                        >{{ optvote.count }} Vote
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
              <div v-if="questionId == ques.QuesID" class="total-result">
                <p>
                  {{ $t("rightpanel.totvote") }}
                  <span>{{ ques.totVote }}</span>
                </p>
              </div>
            </div>
          </div>
          <div v-if="ques.fieldtype === 'text'" class="perfect-word-text-box">
            <div class="highlight-ans">
              <div class="d-flex justify-center position-relative">
                <vue-word-cloud
                  style="height: 260px; width: 100%"
                  animation-duration="1000"
                  animation-easing="ease"
                  animation-overlap="1"
                  enter-animation="bounce"
                  font-family="Anton"
                  leave-animation="bounce"
                  spacing="0.5"
                  :words="ques.tagData"
                  :color="
                    ([, weight]) =>
                      weight > 4
                        ? '#ffd077'
                        : weight > 3
                        ? '#3bc4c7'
                        : weight > 2
                        ? '#3a9eea'
                        : weight > 1
                        ? '#ff4e69'
                        : '#461e47'
                  "
                >
                  <template slot-scope="{ text, weight }">
                    <div :title="weight" style="cursor: pointer">
                      {{ text }}
                    </div>
                  </template>
                </vue-word-cloud>
              </div>
              <div class="total-result">
                <p>
                  {{ $t("rightpanel.totvote") }}
                  <span>{{ ques.totVote }}</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import db from "@/components/firebaseInit";
import jQuery from "jquery";
let $ = jQuery;
import VueWordCloud from "vuewordcloud";
import axios from "axios";
import APIs from "@/components/APIInit";
import { bus } from "@/main";

let vm;
var pollPublishListener;
var pollRessultInterval;
export default {
  components: {
    [VueWordCloud.name]: VueWordCloud,
  },
  data() {
    return {
      clientId: "",
      eventId: "",
      sessionId: "",
      surveyId: "",
      questionId: "",
      pollQuestionList: [],
      event_collectionName: "",
      optionChar: [
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "k",
        "L",
        "M",
        "N",
      ],
    };
  },
  computed: {},
  watch: {},
  created() {
    vm = this;
    vm.clientId = vm.$route.params.cid ? vm.$route.params.cid : "";
    vm.eventId = vm.$route.params.eid ? vm.$route.params.eid : "";
    vm.sessionId = vm.$route.params.sid ? vm.$route.params.sid : "";
    vm.surveyId = vm.$route.params.qid ? vm.$route.params.srvid : "";
    vm.questionId = vm.$route.params.qid ? vm.$route.params.qid : "";

    if (vm.clientId && vm.eventId && vm.sessionId && vm.questionId) {
      vm.event_collectionName = "OA_UAT_" + vm.clientId + vm.eventId;
      bus.$emit("toggleLoader", true);
      vm.getPollQuestion(vm.sessionId, vm.surveyId, vm.questionId);
    }
    setTimeout(() => {
      if ($("#topmenu")) {
        $("#topmenu").addClass("d-none");
      }
      if ($("#leftMenuParent")) {
        $("#leftMenuParent").addClass("d-none");
      }
      if ($("#leftmenu")) {
        $("#leftmenu").hide();
      }
    }, 100);
  },
  mounted() {
    $(".disable-action").tooltip();
  },
  beforeUpdate() {
    //alert("");
  },
  beforeDestroy() {
    //alert("beforeDestroy:RightPanel");
    //window.removeEventListener("beforeunload", this.beforeWindowUnload);
    if (pollPublishListener) {
      pollPublishListener();
    }
    if (pollRessultInterval) {
      clearInterval(pollRessultInterval);
    }
  },
  methods: {
    ViewPollResult(val, type) {
      if (pollRessultInterval) {
        clearInterval(pollRessultInterval);
      }
      pollRessultInterval = setInterval(function () {
        vm.GetPollResult(val, type);
      }, 3000);
    },
    getPollQuestion(sessionId, surveyId, questionId) {
      debugger;
      vm.pollQuestionList = [];
      if (pollPublishListener) {
        pollPublishListener();
      }
      console.log("selectsessionID : " + sessionId);

      let firstLoad = true;
      db.collection(vm.event_collectionName)
        .doc("FormList")
        .collection("Forms")
        .doc(sessionId)
        .collection("PollForms")
        .doc(surveyId)
        .onSnapshot((doc) => {
          //var isflag = false;
          var activeCount = 0;
          //var activeQuestionId = "";

          var activeQuestionId = "";
          var activeQuestionFieldType = "";
          var activeQuestionSurveyID = "";
          if (doc.exists) {
            let data = doc.data();
            var fields = data.FormJson;
            //if (fields[0].isActive) {
            //  isflag = fields[0].isActive;
            //}
            if (fields.length > 0) {
              var i;
              for (i = 0; i < fields.length; ++i) {
                if (questionId == fields[i].cid) {
                  if (fields[i].userid) {
                    let Qs = vm.pollQuestionList.filter(function (item) {
                      return item.SurveyID == doc.id;
                    });
                    if (Qs.length == 0) {
                      activeCount++;
                      activeQuestionId = fields[i].cid;
                      activeQuestionFieldType = fields[i].field_type;
                      activeQuestionSurveyID = doc.id;
                      vm.pollQuestionList.push({
                        QuesID: fields[i].cid,
                        Question: fields[i].label,
                        Options: fields[i].field_options.options,
                        fieldtype: fields[i].field_type,
                        isActive: fields[i].isActive,
                        SurveyID: doc.id,
                        UserID: fields[i].userid,
                        LastPublishedAt: fields[i].LastModifiedDate.seconds,
                        IsSubmitted: false,
                        IsSubmitting: false,
                        vote: [],
                        tagData: [],
                        totVote: 0,
                      });
                    } else {
                      activeCount++;
                      activeQuestionId = fields[i].cid;
                      activeQuestionFieldType = fields[i].field_type;
                      activeQuestionSurveyID = doc.id;
                      Qs[0].isActive = fields[i].isActive;
                      Qs[0].LastPublishedAt =
                        fields[i].LastModifiedDate.seconds;
                    }
                  }
                  //console.log(vm.pollQuestionList);
                }
              }
            }
          }
          //let activeList = vm.pollQuestionList.filter(function (item) {
          //  return item.isActive;
          //});
          //if (activeList.length > 0 && isflag) {
          //  if (activeList.length == 1) {
          //    //var ind = vm.pollQuestionList.findIndex((o) => o.isActive === true);
          //    //vm.showVotingOption(
          //    //  vm.pollQuestionList[ind].QuesID,
          //    //  vm.pollQuestionList[ind].fieldtype,
          //    //  vm.pollQuestionList[ind].SurveyID
          //    //);
          //  } else {
          //    //vm.showVotingOption(
          //    //  activeList[0].QuesID,
          //    //  activeList[0].fieldtype,
          //    //  activeList[0].SurveyID
          //    //);
          //  }
          //}

          // var actPoll = vm.pollQuestionList.filter(function (u) {
          //   return u.isActive;
          // });
          // actPoll = actPoll.sort(function (a, b) {
          //   return b.LastPublishedAt - a.LastPublishedAt;
          // });
          // var myPoll = vm.pollQuestionList.filter((u) => {
          //   return u.UserID.includes(vm.uid) && !u.isActive;
          // });
          // myPoll = myPoll.sort(function (a, b) {
          //   return b.LastPublishedAt - a.LastPublishedAt;
          // });
          // var activeList = actPoll.concat(myPoll);

          // if (activeList.length <= 0) {
          //   vm.hidePollPopup();
          // }

          // vm.pollQuestionList = activeList.filter(function () {
          //   return true;
          // });
          // if (activeCount == 1) {
          //   vm.updatePollSubmitStatus(
          //     activeQuestionId,
          //     activeQuestionFieldType,
          //     activeQuestionSurveyID,
          //     firstLoad
          //   );
          // } else {
          //   vm.updatePollSubmitStatus(
          //     activeQuestionId,
          //     activeQuestionFieldType,
          //     activeQuestionSurveyID,
          //     firstLoad
          //   );
          // }
          firstLoad = false;
          bus.$emit("toggleLoader", false);
          vm.ViewPollResult(
            vm.pollQuestionList[0].QuesID,
            vm.pollQuestionList[0].fieldtype
          );
          console.log(firstLoad);
          console.log(activeCount);
          console.log(activeQuestionId);
          console.log(activeQuestionFieldType);
          console.log(activeQuestionSurveyID);
        });
    },
    GetPollResult(val, type) {
      console.log(new Date());
      var requestData = {
        clientId: vm.clientId,
        eventId: vm.eventId,
        sessionId: vm.sessionId,
        pollType: "1",
        questionId: val,
      };
      var headers = {
        "Content-Type": "application/json",
        "x-api-key": APIs.PollXApiKey,
      };
      axios
        .post(APIs.GetPollResult, requestData, {
          headers: headers,
        })
        .then((responseData) => {
          let res = responseData.data;
          var result = JSON.parse(JSON.stringify(res));
          vm.pollQuestionList.forEach(function (q) {
            if (q.QuesID == val) {
              q.vote = result.options;
              q.vote.forEach(function (v) {
                v.count = parseFloat(v.count);
              });
              q.vote = q.vote.sort(function (a, b) {
                var A = a.count;
                var B = b.count;
                return B - A;
              });
              if (result.submitCount > 0) {
                q.totVote = parseInt(result.submitCount);
              } else {
                q.totVote = 0;
              }
              console.log("Vote count: " + q.vote);
              if (type != "checkboxes") {
                q.tagData = [];
                var tagTotVote = 0;

                for (var i = 0; i < q.vote.length; i++) {
                  //q.tagData.push({
                  //  text: q.vote[i].optionId,
                  //  weight: parseInt(q.vote[i].count),
                  //});
                  q.tagData.push([
                    q.vote[i].optionId,
                    parseInt(q.vote[i].count),
                  ]);
                  tagTotVote = parseInt(tagTotVote) + parseInt(q.vote[i].count);
                }
                q.totVote = tagTotVote;
              }
            }
          });
        })
        .catch(function (exception) {
          if (pollRessultInterval) {
            clearInterval(pollRessultInterval);
          }
          vm.hidePollPopup();
          console.log(exception);
        });
    },
  },
};
</script>